import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ChatItem from "../../../Components/Consultation/ChatItem";
import {
  faCommentDots,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useTenantContent } from "../../../Context/TenantContentContext";
import Loader from "../../../Components/Core/Loader";

const ChatActive = (props) => {
  const { content, loading } = useTenantContent();

  if (loading || !content) {
    return <Loader />;
  }

  return (
    <div className="section-card">
      <div className="section-header">
        <div className="section-icon">
          <FontAwesomeIcon icon={faCommentDots} />
        </div>
        <h2 className="section-title">مشاوره فعال</h2>
      </div>

      {props.activeSession ? (
        <>
          <div className="active-consultation-badge">
            <FontAwesomeIcon icon={faCheckCircle} />
            مشاوره های شما
          </div>
          <ChatItem
            session={props.activeSession}
            handleJoinChat={props.handleJoinChat}
            isFromUser={true}
            drImgSrc={content.doctorAvatarUrl}
          />
        </>
      ) : (
        <div className="empty-state">
          <div className="empty-state-icon">
            <FontAwesomeIcon icon={faCommentDots} />
          </div>
          <h3>هیچ مشاوره فعالی وجود ندارد</h3>
          <p>
            برای شروع جلسه مشاوره، روی دکمه "درخواست مشاوره جدید" کلیک کنید.
          </p>
        </div>
      )}
    </div>
  );
};

ChatActive.propTypes = {};

export default ChatActive;
